import { render } from "./CardPromHeader.vue?vue&type=template&id=613a572a"
import script from "./CardPromHeader.vue?vue&type=script&lang=js"
export * from "./CardPromHeader.vue?vue&type=script&lang=js"

import "./CardPromHeader.vue?vue&type=style&index=0&id=613a572a&lang=scss"
import "./CardPromHeader.vue?vue&type=style&index=1&id=613a572a&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__